import React from 'react';
import { SearchBox as MenuSearchBox } from '@fluentui/react/lib/SearchBox';

const SearchBox = (props) => {
    const inputParam_Display = props.display !== null && props.display !== undefined ?  props.display : false;

    const onRenderSearchStyle = { root: { marginTop: '7px', height: "25px" } };

    return (
        <MenuSearchBox
            styles={onRenderSearchStyle}
            className={`${inputParam_Display ? "d-unset" : "d-none"}`}
            placeholder="Search"
            //onSearch={newValue => console.log('value is ' + newValue)}
        />
    )
}
export default SearchBox